import React, { useCallback, useEffect, useMemo, useState } from "react"
import { CSSTransition } from "react-transition-group"
import i18nData from "@rogue_4/locales/zh-CN.json"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import { i18n } from "@/utils/i18n"
import GAME_ITEM_DICT from "../../../data/item"
import { useGameItemDict } from "../../../store"
import { IGameItem } from "../../../type"
import { SFX } from "../../../utils/sound"
import { getTransitionClassnames } from "../../../utils/transition"
import ItemFrame from "../../ItemFrame"
import ModalTitle from "../common/modalTitle"
import { useGameItemModal, useGameModalStore } from "../store"

import styles from "./index.module.less"

export const ItemUnit: React.FC<{
    item?: IGameItem
    noClick?: boolean
    className?: string
    imgClassName?: string
    label?: string
}> = ({ item, noClick, className, imgClassName, label }) => {
    const callItemModal = useGameItemModal()
    const handleClick = useCallback(() => {
        if (noClick) return
        if (item) {
            SFX.play("commonClick")
            callItemModal(item, true)
        }
    }, [callItemModal, item, noClick])
    return (
        <div
            className={classNames(
                styles.item,
                !item && styles.noItem,
                className
            )}
            onClick={handleClick}
        >
            <ItemFrame
                className={classNames(styles.img, imgClassName)}
                img={item?.image ?? ""}
            />
            <div className={styles.label}>
                {label ??
                    item?.name ??
                    i18n(i18nData, "rogue_4.game.backpack.miss")}
            </div>
        </div>
    )
}

const BackpackModal: StyledComponent = ({ className, style }) => {
    const [active, setActive] = useState(false)
    useEffect(() => {
        useGameModalStore.setState({
            callBackpackModal: () => {
                setActive(true)
            },
        })
    }, [])
    const itemDict = useGameItemDict()
    const items = useMemo(() => Object.keys(itemDict), [itemDict])
    return (
        <CSSTransition
            in={active}
            timeout={300}
            classNames={getTransitionClassnames(styles)}
        >
            <div
                className={classNames(styles.backpackModal, className)}
                style={style}
                onClick={(e) => {
                    e.stopPropagation()
                }}
            >
                <ModalTitle className={styles.title}>
                    {i18n(i18nData, "rogue_4.game.title.backpack")}
                </ModalTitle>
                <div className={styles.content}>
                    <div className={styles.line}>
                        <ItemUnit item={GAME_ITEM_DICT[items[0] ?? ""]} />
                        <ItemUnit item={GAME_ITEM_DICT[items[1] ?? ""]} />
                        <ItemUnit item={GAME_ITEM_DICT[items[2] ?? ""]} />
                    </div>
                    <div className={styles.line}>
                        <ItemUnit item={GAME_ITEM_DICT[items[3] ?? ""]} />
                        <ItemUnit item={GAME_ITEM_DICT[items[4] ?? ""]} />
                        <ItemUnit item={GAME_ITEM_DICT[items[5] ?? ""]} />
                    </div>
                </div>
                <div
                    className={styles.backButton}
                    onClick={() => {
                        SFX.play("commonClick")
                        setActive(false)
                    }}
                ></div>
            </div>
        </CSSTransition>
    )
}

export default BackpackModal
